import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { openFile, useFileUrl } from 'supports/helpers/openDocument';

const ModalPreviewPOProof = ({ isOpen, toggle, proofData }) => {
  // Signed link for the proof, minted when the modal opens (it lives 60 s).
  const url = useFileUrl(isOpen ? proofData : null);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>Preview PO Proof</ModalHeader>
      <ModalBody>
        {url && (
          <button
            type="button"
            className="btn p-0 border-0 w-100"
            title="Open in a new tab"
            onClick={() => openFile(proofData)}
          >
            <img src={url} alt="po-proof" width="100%" />
          </button>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalPreviewPOProof;
